import { getEnvRequired } from '../../shared/utilities/env';
import { ApiClient } from '../shared/api/client';

import { serializeMessageTemplateFromAPI } from './serializers';
import {
    MessageTemplate,
    MessageTemplatesJSONAPIResponse,
    DraftMessageTemplate,
    MessageTemplateId,
} from './types';

const MESSAGE_TEMPLATE_API_URL = getEnvRequired('MESSAGE_TEMPLATE_API_URL');

const apiClient = new ApiClient(false);

export async function fetchMessageTemplates() {
    const url = `${MESSAGE_TEMPLATE_API_URL}/templates`;

    const response = await apiClient.get<MessageTemplatesJSONAPIResponse>(url);
    return serializeMessageTemplateFromAPI(response);
}

export async function deleteMessageTemplate(id: MessageTemplateId) {
    const url = `${MESSAGE_TEMPLATE_API_URL}/templates/${id}`;
    await apiClient.delete(url);
}

export async function postMessageTemplate(messageTemplate: DraftMessageTemplate) {
    const url = `${MESSAGE_TEMPLATE_API_URL}/templates`;
    const formData = new window.FormData();
    formData.append('title', messageTemplate.title);
    formData.append('content', messageTemplate.content);

    const response = await apiClient.postForm<MessageTemplatesJSONAPIResponse>(url, formData);
    return serializeMessageTemplateFromAPI(response);
}

export async function patchMessageTemplate(messageTemplate: MessageTemplate) {
    const url = `${MESSAGE_TEMPLATE_API_URL}/templates/${messageTemplate.id}`;
    await apiClient.patch(url, JSON.stringify(messageTemplate));
}
